import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { FindRewardItemByCodeProduct } from '../types/findRewardItemByCode.type'
import { CircleXIcon, ShoppingBasket } from 'lucide-react'
import Skeleton from '@/common/components/Skeleton'
import Alert from '@/common/components/Alert'

interface RewardItemPreviewProps {
  rewardItem?: FindRewardItemByCodeProduct
  rewardItemIsLoading?: boolean
  rewardItemError?: Error | null
}

export default function RewardItemPreview({
  rewardItem,
  rewardItemIsLoading,
  rewardItemError
}: RewardItemPreviewProps) {
  if(!rewardItem && !rewardItemIsLoading && !rewardItemError) return null

  if(rewardItemIsLoading) {
    return <Skeleton className='w-full h-[50px] rounded' />
  }

  if(rewardItemError) {
    return (
      <Alert Icon={CircleXIcon} variant="error" containerClassName='h-[50px] rounded'>
        <p className="text-danger-soft text-sm" data-testid="alert_reward_item_not_found">
          Recompensa não encontrada
        </p>
      </Alert>
    )
  }

  return (
    <div className='flex items-center gap-3 h-[50px] overflow-hidden rounded bg-white-200'>
      <ImageWithPlaceholder
        url={rewardItem?.pictures?.length ? rewardItem?.pictures[0]?.url : undefined}
        alt={rewardItem?.display_name}
        placeholderIcon={ShoppingBasket}
        className="w-full max-h-[50px] size-auto rounded-none bg-white-800 aspect-[1/1]"
        iconClassName="size-[50px]"
      />
      <span className='text-sm'>{rewardItem?.display_name}</span>
    </div>
  )
}
